import { RelationshipRecordType } from './graphql';

// Runtime array of RelationshipRecordType values. Kept separate from generated file
// because the codegen emits a type-only union (no runtime object).
export const RelationshipRecordTypeValues: RelationshipRecordType[] = [
  'BoundaryValues',
  'CountryOfOrigin',
  'Dictionary',
  'Dimension',
  'Maximum',
  'Minimum',
  'PossibleValues',
  'Properties',
  'QuantityKinds',
  'ReferenceDocuments',
  'RelationshipToProperty',
  'RelationshipToSubject',
  'ReplacedObjects',
  'ScopeSubjects',
  'SimilarTo',
  'Subdivisions',
  'Subject',
  'Symbols',
  'TargetProperties',
  'TargetSubjects',
  'Unit',
  'Units',
  'Value',
  'Values',
];

export default RelationshipRecordTypeValues;
